import styled from "styled-components";
import { colors } from "../../components/common/element/elements";

export const ScholarshipWrapper = styled.section`
  padding: 30px 0;

  margin: 0 auto;
`;

export const ScholarshipSection = styled.div`
  margin-bottom: 40px;

  h5 {
    margin-bottom: 20px;
    font-weight: 600;
    color: ${colors.black1};
    font-size: 24px;
  }

  p {
    color: ${colors.text2};
    line-height: 1.8;
    font-size: 16px;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    &.fw-bold {
      font-weight: 600;
      color: ${colors.black2};
    }
  }

  ul,
  ol {
    padding: 12px 0;
    li {
      display: flex;
      column-gap: 10px;
      border-radius: 8px;
      box-shadow: 0 1px 10px 5px rgb(0 0 0 / 3%);
      padding: 10px 15px;
      font-size: 15px;
      color: ${colors.text3};
      line-height: 25px;
      margin-bottom: 15px;
    }

    li.item {
      i {
        color: ${colors.bg1};
        font-size: 20px;
      }
    }
  }

  a {
    color: teal;
    text-decoration: underline;
    font-weight: 500;
  }
`;

export const ExamResultsStyles = styled.div`
  padding: 32px 0;

  .info,
  .marking {
    margin-bottom: 40px;
  }

  .info-list,
  .marking-list {
    border-left: 4px solid ${colors.bg1};
    padding-left: 16px;
    border-radius: 4px;
    margin-bottom: 16px;
    margin-top: 16px;
  }

  ul {
    padding: 12px 0;
    li {
      display: flex;
      column-gap: 10px;
      border-radius: 8px;
      box-shadow: 0 1px 10px 5px rgb(0 0 0 / 3%);
      padding: 10px 15px;
      font-size: 15px;
      color: ${colors.text3};
      line-height: 25px;
      margin-bottom: 15px;
    }

    li.item {
      i {
        color: ${colors.bg1};
        font-size: 20px;
      }
    }
  }
  a {
    color: ${colors.bg2};
    font-weight: 500;
    text-decoration: underline;
  }

  .contact {
    a {
      color: #000;
      text-decoration: none;
    }
  }
`;
